import React from 'react';
import { useHistory } from "react-router-dom";
import ls from 'local-storage';
import { useState } from 'react';
import { useEffect } from 'react';
import { Button, Popover } from 'antd';
import API from "../../Services/BaseService";
import ManageAccountLinks from "../../Component/ManageAccountLinks/ManageAccountLinks"
import Popup from '../../Component/Popup/Popup';
import '../../Component/Popup/popup.css';
import CommonPopup from '../../Component/CommonPopup/CommonPopup';
import 'antd/dist/antd.css';
import { useSelector, useDispatch } from 'react-redux';
import appstore from '../../assets/img/appstore.png';
import googleplay from '../../assets/img/googleplay.png';
import Loading from "../../Component/Loading/Loading";
import PageNotFound from '../FallBackUI/PageNotFound';
import DealerAction from '../DealerRedux/DealerAction';
import { Modal } from 'react-bootstrap';
const Notification = () => {
	const history = useHistory();
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(true);
	const [isOpen, setIsOpen] = useState(false);
	const successData = useSelector(state => state.LoginReducer.payload);
	const dealerData = useSelector(state => state.DealerReducer.payload);
	console.log("successData=====", successData)

	const [dealerList, setDealerList] = useState("");
	const [dealerId, setDealerId] = useState("");
	const [selectedSellerDetails, setSelectedSellerDetails] = useState("");
	const [selectSellerId, setselectSellerid] = useState("");
	const [flagFilter, setFalgFilter] = useState(false);

	const togglePopup = () => {
		setIsOpen(!isOpen);
	}
	const [popupTitle, setPopupTitle] = useState("");
	const [popupMsg, setPopupMsg] = useState("");
	const [popupType, setPopupType] = useState("");
	const [popupActionType, setPopupActionType] = useState("");
	const [popupActionValue, setPopupActionValue] = useState("");
	const [popupActionPath, setPopupActionPath] = useState("")

	const [notification, setNotification] = useState("no");
	const [notificationLength, setNotificationLength] = useState("");
	const [email, setEmail] = useState("instant");
	console.log("setEmail", email)
	const [sms, setSms] = useState("instant");
	const [push_notification, setPush_notification] = useState("yes");
	const [femail, setFavEmail] = useState("daily");
	const [fsms, setFavSms] = useState("daily");
	const [popupcontent, setPopupcontent] = useState("");
	const [errors, setErrors] = useState("");
	const [errorFlag, setErrorFlag] = useState(false);
	const [changesArray, setChangesArray] = useState([]);
	const [changesFlag, setChangesFlag] = useState("no");


	console.log(changesArray, "changesArray");
	const [confirmationFlag, setConfirmationFlag] = useState(false);

	const confirmationPopup = () => {

		setConfirmationFlag(!confirmationFlag)

	}
	const customButtonStyle = {
		backgroundColor: "RGB(189,6,44)",
		color: "white",
		height: '40px'
	};

	let userDetails = ls.get('userDetails');
	const content = (
		<div>
			<Popover>
				<p>please reach out ursecondlot Admin</p>
			</Popover>
		</div>
	);
	let hover = false;
	var date = new Date()
	console.log("check", date)
	var date1 = date.getUTCFullYear() + "-" + (date.getUTCMonth() + 1) + "-" + date.getUTCDate() + " " + date.getUTCHours() + ":" + date.getUTCMinutes();

	async function getNotification(data) {
		let request = {
			// seller_dealer_id: data == undefined ?dealerData !== null ? dealerData.seller_dealer_id: successData.seller_dealer_id :data ,
			seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,

			seller_id: successData.seller_id,
			seller_token: successData.seller_token,

		};
		const state = API.post('seller_notification/condition', request);
		state.then(res => {
			setLoading(false)
			console.log("res", res.data.data)
			if (res.data.success === true) {
				setNotificationLength(res.data.data.length)
				console.log("seller_notification", res.data.data.length);

				setNotification(res.data.data[0]);
				setEmail(res.data.data[0].email)
				console.log("setEmail123", res.data.data?.email);
				setSms(res.data.data[0].sms)
				setPush_notification(res.data.data[0].push_notification)
				setFavEmail(res.data.data[0].favorite_email)
				setFavSms(res.data.data[0].favorite_sms)
				setLoading(false);
			}
			else {
				setErrors(res.data.error)
				setErrorFlag(true)
			}

		})
			.catch(function (error) {
				if (error.response) {
					setErrors(error.response.data.error)
					setErrorFlag(true)
					setLoading(false);
				}
			});
	}

	useEffect(() => {
		getNotification(dealerData);
		// fetchState();
		getDealername();
	}, [dealerData]);

	const savehandleclick = (data, flag) => {

		let request = {
			// seller_dealer_id: flagFilter == true ? selectSellerId : dealerData !== null ? dealerData.seller_dealer_id : successData.seller_dealer_id,
			seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,

			email: email,
			sms: sms,
			push_notification: push_notification,
			favorite_email: femail,
			favorite_sms: fsms,
			active: 1,
			updatedAt: date1,
			seller_id: successData.seller_id,
			seller_token: successData.seller_token,
			historylist: changesArray,
			valuechanges: changesFlag,
		};
		console.log("getDealername", request)
		//   return
		API.post("seller_notification/add", request)
			.then((response) => {
				setConfirmationFlag(false)
				console.log("res", response.data.success)
				if (response.data.success) {
					togglePopup()
					setPopupTitle("Create Notification");
					setPopupMsg("Notification Successfully Created");
					setPopupType("success");
					setPopupActionType("close");
					setPopupActionValue("Ok");
					// setPopupActionPath("/notification")
					setChangesArray([]);
				} else {
					togglePopup()
					setPopupTitle("Create Notification");
					setPopupMsg("Notification is not Created, Please try Again");
					setPopupType("error");
					setPopupActionType("close");
					setPopupActionValue("close");

				}
			},
				(error) => {
					togglePopup()
					setPopupTitle("Error");
					setPopupMsg("Something went wrong, Please try Again");
					setPopupType("error");
					setPopupActionType("close");
					setPopupActionValue("close");
				})
			.catch(function (error) {
				if (error.response) {
					setErrors(error.response.data.error)
					setErrorFlag(true)
				}
			});

	}

	const handleSellerDetailsName = (e) => {

		setDealerId(e.target.value)
		console.log("=========check seller details name", e.target.value)
		setSelectedSellerDetails(dealerList.filter(data => data.seller_dealer_id == e.target.value)[0])
		console.log("=========check", dealerList.filter(data => data.seller_dealer_id == e.target.value))
		const selectedSellerDetails = dealerList.filter(data => data.seller_dealer_id == e.target.value)[0];
		setNotification("no");
		setEmail("instant")
		setSms("instant")
		setPush_notification("yes")
		setFavEmail("daily")
		setFavSms("daily")
		getfileterNotification(selectedSellerDetails);
		setselectSellerid(selectedSellerDetails.seller_dealer_id)
		setFalgFilter(true)
		dispatch(DealerAction.searchrequest(selectedSellerDetails));

	}

	useEffect(() => {
		if (dealerData !== null) {

			getfileterNotification(dealerData);
		}
	}, [dealerData])

	const getDealername = (data) => {

		let request = {
			seller_id: successData.seller_id,
			seller_token: successData.seller_token,
		}
		API.post("dealerNameDynamic/condition", request).then(response => {
			if (response.data.success === true) {


				setDealerList(response.data.data);

			}

			else {
				setErrors(response.data.error.name)
				setErrorFlag(true)
			}


		})
			.catch(function (error) {
				if (error.response) {
					setErrors(error.response.data.error)
					setErrorFlag(true)
				}
			});
	}

	const getfileterNotification = (data) => {

		let request = {
			seller_dealer_id: data.seller_dealer_id,
			seller_id: successData.seller_id,
			seller_token: successData.seller_token
		}
		API.post("seller_notificationFilter/condition", request).then(res => {
			if (res.data.success === true) {
				setNotification(res.data.data[0]);
				setEmail(res.data.data[0].email)
				console.log("setEmail1234", res.data.data?.email);
				setNotificationLength(res.data.data.length)
				console.log("seller_notificationFilter", res.data.data.length);
				setSms(res.data.data[0].sms)
				setPush_notification(res.data.data[0].push_notification)
				setFavEmail(res.data.data[0].favorite_email)
				setFavSms(res.data.data[0].favorite_sms)
			}

			else {
				setErrors(res.data.error.name)
				setErrorFlag(true)
			}
		})
			.catch(function (error) {
				if (error.res) {
					setErrors(error.res.data.error)
					setErrorFlag(true)
				}
			});
	}

	const handleEmailChange = (e) => {
		setChangesFlag("yes")
		const newValue = e.target.value;
		const oldvalue = notification?.email == null ? "" : notification?.email;
		setEmail(newValue);
		const existingChangeIndex = changesArray.findIndex(change => change.name === "Email");
		if (existingChangeIndex !== -1) {
			const updatedChangesArray = [...changesArray];
			updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: "Email" };
			setChangesArray(updatedChangesArray);
		} else {
			const change = { oldvalue, newvalue: newValue, name: "Email" };
			setChangesArray([...changesArray, change]);
		}
	}

	const handleSmsChange = (e) => {
		setChangesFlag("yes")
		const newValue = e.target.value;
		const oldvalue = notification?.sms == null ? "" : notification?.sms;
		setSms(newValue);
		const existingChangeIndex = changesArray.findIndex(change => change.name === "SMS");
		if (existingChangeIndex !== -1) {
			const updatedChangesArray = [...changesArray];
			updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: "SMS" };
			setChangesArray(updatedChangesArray);
		} else {
			const change = { oldvalue, newvalue: newValue, name: "SMS" };
			setChangesArray([...changesArray, change]);
		}
	}

	const handlePushNotificationChange = (e) => {
		setChangesFlag("yes")
		const newValue = e.target.value;
		const oldvalue = notification?.push_notification == null ? "" : notification?.push_notification;
		setPush_notification(newValue);
		const existingChangeIndex = changesArray.findIndex(change => change.name === "Push Notification");
		if (existingChangeIndex !== -1) {
			const updatedChangesArray = [...changesArray];
			updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: "Push Notification" };
			setChangesArray(updatedChangesArray);
		} else {
			const change = { oldvalue, newvalue: newValue, name: "Push Notification" };
			setChangesArray([...changesArray, change]);
		}
	}

	const handleFavoriteEmailChange = (e) => {
		setChangesFlag("yes")
		const newValue = e.target.value;
		const oldvalue = notification?.favorite_email == null ? "" : notification?.favorite_email;
		setFavEmail(newValue);
		const existingChangeIndex = changesArray.findIndex(change => change.name === "Favorite Email");
		if (existingChangeIndex !== -1) {
			const updatedChangesArray = [...changesArray];
			updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: "Favorite Email" };
			setChangesArray(updatedChangesArray);
		} else {
			const change = { oldvalue, newvalue: newValue, name: "Favorite Email" };
			setChangesArray([...changesArray, change]);
		}
	}

	const handleFavoriteSmsChange = (e) => {
		setChangesFlag("yes")
		const newValue = e.target.value;
		const oldvalue = notification?.favorite_sms == null ? "" : notification?.favorite_sms;
		setFavSms(newValue);
		const existingChangeIndex = changesArray.findIndex(change => change.name === "Favorite SMS");
		if (existingChangeIndex !== -1) {
			const updatedChangesArray = [...changesArray];
			updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: "Favorite SMS" };
			setChangesArray(updatedChangesArray);
		} else {
			const change = { oldvalue, newvalue: newValue, name: "Favorite SMS" };
			setChangesArray([...changesArray, change]);
		}
	}


	return (
		<div>
			{loading ? <Loading /> :
				<main id="main" className="inner-page">
					{errorFlag === true ? <PageNotFound error={errors} /> :

						<div id="notificationaccount" className="notificationaccount">

							<div className="container-fluid inner-page-space" >

								<div class="back-btn">
									<a class="back-btn-primary" onClick={() => history.push("/carlist")}>
										<i class="bx bx-chevron-left"></i> Back
									</a>
								</div>
								<div className="notificationaccountblock col-lg-12">
									<div className="section-title">
										<h2>Notification</h2>
									</div>
									<div class="notification">
										{/* <div class='drop-down-sec'>
                    <div class="col-sm-12"> */}
										<div class="dealename-drop-down-note">
											<select
												className={`${dealerData != null ? (dealerData?.color == "pink"
													? "tableRowPink  form-control box"
													: dealerData?.color == "firered"
														? "tableRowFireRed  form-control box"
														: dealerData?.color == "green"
															? "tableRowGreenColor form-control box"
															: dealerData?.color == "darkred"
																? "tableRowRed1  form-control box"
																: " form-control box") :
													(dealerList[0]?.color == "pink"
														? "tableRowPink  form-control box"
														: dealerList[0]?.color == "firered"
															? "tableRowFireRed  form-control box"
															: dealerList[0]?.color == "green"
																? "tableRowGreenColor form-control box"
																: dealerList[0]?.color == "darkred"
																	? "tableRowRed1  form-control box"
																	: " form-control box")}`}
												value={dealerId} // Set the value attribute to dealerId
												onChange={handleSellerDetailsName}
											>
												{dealerData != null ?
													<option value={null} style={{ "display": "none" }}>{dealerData.dealer_name}({dealerData?.seller_dealer_id})</option> :
													<option value={null} style={{ "display": "none" }}>{dealerList[0]?.dealer_name}({dealerList[0]?.seller_dealer_id})</option>}
												{dealerList.length > 0 &&
													<>
														{dealerList.map((dealerList, index) =>
															<option
																className={dealerList?.color == "pink"
																	? "tableRowPink  user_name"
																	: dealerList?.color == "Silver"
																		? "tableRowSilver  user_name"
																		: dealerList?.color == "Orange"
																			? "tableRowOrange  user_name"
																			: dealerList?.color == "Navy blue"
																				? "tableRowNavyBlue  user_name"
																				: dealerList?.color == "firered"
																					? "tableRowFireRed  user_name"
																					: dealerList?.color == "Purple"
																						? "tableRowPurple  user_name"
																						: dealerList?.color == "Yellow"
																							? "tableRowYellow1  user_name"
																							: dealerList?.color == "green"
																								? "tableRowGreenColor user_name"
																								: dealerList?.color == "blue"
																									? "tableRowBlue  user_name"
																									: dealerList?.color == "darkred"
																										? "tableRowRed1  user_name"
																										: dealerList?.color == "black"
																											? "tableRowBlack1 user_name"
																											: " user_name"}
																key={dealerList.seller_dealer_id}
																value={dealerList.seller_dealer_id}
															>
																{dealerList.dealer_name}({dealerList?.seller_dealer_id})
															</option>
														)}
													</>
												}
											</select>


										</div>
									</div>
									<div className="row content">
										<div className="col-lg-4 col-md-12 col-sm-12 accountleftblock">

											<ManageAccountLinks />
										</div>
										<div className="col-lg-8 col-md-12 col-sm-12 notificationaccountrightblock">
											<div className="notificationrighttableblock">
												<h2>Bids</h2>
												<div className="notificationtabblock col-lg-12">
													<h3>Email</h3>
													<div className="row">
														<form className="bidsemailblock">
															<div className="col-lg-4 col-md-12">
																<div className="radio input-group">
																	<input id="radioinsta" checked={email === "instant" ? true : false} value="instant" name="radio" type="radio" onChange={handleEmailChange} />
																	<label htmlFor="radioinsta" className="radio-label">Instant Email</label>
																	<p>Don't miss any deal! we will send you emails immediately with any new bid activity</p>
																</div>
															</div>
															<div className="col-lg-4 col-md-12">
																<div className="radio input-group">
																	<input id="radioupdate" checked={email === "daily" ? true : false} value="daily" name="radio" type="radio" onChange={handleEmailChange} />
																	<label htmlFor="radioupdate" className="radio-label">Daily Update</label>
																	<p>You will receive an email daily of new bid activity</p>
																</div>
															</div>

															<div className="col-lg-4 col-md-12">
																<div className="radio input-group">
																	<input id="radioweek" checked={email === "weekly" ? true : false} value="weekly" name="radio" type="radio" onChange={handleEmailChange} />
																	<label htmlFor="radioweek" className="radio-label">Weekly Update</label>
																	<p>You will receive an email weekly of new bid activity</p>
																</div>
															</div>
															{/* <div className="col-lg-3 col-md-3"  >
																<Popover content={content} >
																	<div className="radio input-group">
																		<input id="radionever" checked={email === "no" ? true : false} defaultValue={"no"} name="radio" type="radio" onChange={(e) => setEmail(e.target.value)} />
																		<label htmlFor="radionever" className="radio-label">Never</label>
																		<p>You won't receive any emails for bid activity.</p>
																	</div>
																</Popover>,
															</div> */}
														</form>
													</div>
												</div>

												<div className="notificationtabblock mt-3 pt-4 col-lg-12">
													<h3>SMS (Text Message)</h3>
													<div className="row">
														<form className="bidssmsblock">
															<div className="col-lg-4 col-md-12">
																<div className="radio input-group">
																	<input id="radio-dailyinssms" checked={sms === "instant" ? true : false} value="instant" name="radio" type="radio" onChange={handleSmsChange} />
																	<label htmlFor="radio-dailyinssms" className="radio-label">Instant SMS</label>
																	<p>Don't miss any deal! we will send you SMS immediately with any new bid activity</p>
																</div>
															</div>
															<div className="col-lg-4 col-md-12">
																<div className="radio input-group">
																	<input id="radio-dailysms" checked={sms == "daily" ? true : false} value="daily" name="radio" type="radio" onChange={handleSmsChange} />
																	<label htmlFor="radio-dailysms" className="radio-label">Daily Update</label>
																	<p>You will receive an SMS daily of new bid activity</p>
																</div>
															</div>

															<div className="col-lg-4 col-md-12">
																<div className="radio input-group">
																	<input id="radio-weeklysms" checked={sms == "weekly" ? true : false} value="weekly" name="radio" type="radio" onChange={handleSmsChange} />
																	<label htmlFor="radio-weeklysms" className="radio-label"> Weekly Update</label>
																	<p>You will receive an SMS weekly of new bid activity</p>
																</div>
															</div>

															{/* <div className="col-lg-3 col-md-3">
																<Popover content={content} >
																	<div className="radio input-group">
																		<input id="radio-dailysmsnover" checked={sms == "no" ? true : false} value="no" name="radio" type="radio" onChange={(e) => setSms(e.target.value)} />
																		<label htmlFor="radio-dailysmsnover" className="radio-label">Never</label>
																		<p>You won't receive any SMS for bid activity.</p>
																	</div>
																</Popover>
															</div> */}
														</form>
													</div>
												</div>

												<div className="notificationtabblock mt-3 pt-4 col-lg-12">
													<h3>Push Notification(for Mobile Application)</h3>
													<div className="row">
														<form className="bidsnotiblock">
															<div className="col-lg-4 col-md-12">
																<div className="radio input-group">
																	<input id="radio-dailynotificat" checked={push_notification == "yes" ? true : false} value="yes" name="radio" type="radio" onChange={handlePushNotificationChange} />
																	<label htmlFor="radio-dailynotificat" className="radio-label">Yes</label>
																	<p>You will receive push notifications when any new bid activity directly to your mobile phone.</p>
																</div>
															</div>

															<div className="col-lg-4 col-md-12">
																<Popover content={content} >
																	<div className="radio input-group">
																		<input id="radio-dailyno" checked={push_notification == "no" ? true : false} value="no" name="radio" type="radio" onChange={handlePushNotificationChange} />
																		<label htmlFor="radio-dailyno" className="radio-label">No</label>
																		<p>You won't receive any push notification.</p>
																	</div>
																</Popover>
															</div>
														</form>
													</div>
												</div>
											</div>


											<div className="notificationrighttableblock favoritetableblock  mt-3 pt-4">
												<h2>Favorite Cars</h2>
												<div className="notificationtabblock mt-3 pt-4 col-lg-12">
													<h3>Email</h3>
													<div className="row">
														<form className="favoriteemailblock">
															<div className="col-lg-6 col-md-12">
																<div className="radio input-group">
																	<input id="radio-dailycarsno" checked={femail == "daily" ? true : false} value="daily" name="radio" type="radio" onChange={handleFavoriteEmailChange} />
																	<label htmlFor="radio-dailycarsno" className="radio-label">Daily Update</label>
																	<p>You will receive a daily Email when new vehicle posted matching your Favorite cars</p>
																</div>
															</div>
															<div className="col-lg-6 col-md-12">
																<div className="radio input-group">
																	<input id="radio-weeklycarsno" checked={femail == "weekly" ? true : false} value="weekly" name="radio" type="radio" onChange={handleFavoriteEmailChange} />
																	<label htmlFor="radio-weeklycarsno" className="radio-label">Weekly Update</label>
																	<p>You will receive a weekly Email when new vehicle posted matching your Favorite cars</p>
																</div>
															</div>

															{/* <div className="col-lg-4 col-md-12">
																<Popover content={content} >
																	<div className="radio input-group">
																		<input id="radio-dailycarsnover" checked={femail == "no" ? true : false} value="no" name="radio" type="radio" onChange={(e) => setFavEmail(e.target.value)} />
																		<label htmlFor="radio-dailycarsnover" className="radio-label">Never</label>
																		<p>You won't receive any emails With fresh inventory.</p>
																	</div>
																</Popover>
															</div> */}
														</form>
													</div>
												</div>

												<div className="notificationtabblock mt-3 pt-4 col-lg-12">
													<h3>SMS (Text Message)</h3>
													<div className="row">
														<form className="favoritesmsblock">
															<div className="col-lg-6 col-md-12">
																<div className="radio input-group">
																	<input id="radio-dailysmct" checked={fsms == "daily" ? true : false} value="daily" name="radio" type="radio" onChange={handleFavoriteSmsChange} />
																	<label htmlFor="radio-dailysmct" className="radio-label">Daily Update</label>
																	<p>You will receive a daily SMS when new vehicle posted matching your Favorite cars</p>
																</div>
															</div>

															<div className="col-lg-6 col-md-12">
																<div className="radio input-group">
																	<input id="radio-weeklysmct" checked={fsms == "weekly" ? true : false} value="weekly" name="radio" type="radio" onChange={handleFavoriteSmsChange} />
																	<label htmlFor="radio-weeklysmct" className="radio-label">Weekly Update</label>
																	<p>You will receive a weekly SMS when new vehicle posted matching your Favorite cars</p>
																</div>
															</div>

															{/* 
															<div className="col-lg-4 col-md-12">
																<Popover content={content} >
																	<div className="radio input-group">
																		<input id="radio-dailysmtnover" checked={fsms == "no" ? true : false} value="no" name="radio" type="radio" onChange={(e) => setFavSms(e.target.value)} />
																		<label htmlFor="radio-dailysmtnover" className="radio-label">Never</label>
																		<p>You won't receive any SMS With fresh inventory.</p>
																	</div>
																</Popover>
															</div> */}
														</form>
													</div>
												</div>
											</div>
											<div className="text-center col-lg-12 loginBtn">
												{/* <a href="#" className="save-more-btn">Save</a> */}
												<Button className="save-more-btn cta-btn" style={customButtonStyle} onClick={() => setConfirmationFlag(true)}>{notificationLength > 0 ? "Update" : "Add"}</Button>
											</div>
										</div>
									</div>
								</div>
							</div>

						</div>}

					{confirmationFlag &&

						< >
							<Modal show={true} onHide={confirmationPopup} centered>
								<Modal.Header className="Terms-login">
									<h2>Edit confirmation</h2>
								</Modal.Header>
								<Modal.Body>

									<div className="CommonModalbody">

										<p>Are you sure,If you want to Edit Notification Information please confirm</p>
									</div>
									<div className="col-md-12 btns confirmation ">
										<button className="cta-btns" onClick={confirmationPopup} >CANCEL</button>
										<button className="cta-btns" onClick={() => savehandleclick(dealerData)} >OK</button>
									</div>
								</Modal.Body>
							</Modal>
						</>


					}
					<section id="playstoreBlock" className="playstoreBlock">
						<div className="container">
							<div className="row content">
								<div className="col-lg-12">
									<img src={appstore} />
									<img src={googleplay} />
								</div>
							</div>
						</div>
					</section>
					{isOpen &&
						<CommonPopup
							handleClose={togglePopup}
							popupTitle={popupTitle}
							popupMsg={popupMsg}
							popupType={popupType}
							popupActionType={popupActionType}
							popupActionValue={popupActionValue}
							popupActionPath={popupActionPath}
						/>}
				</main>}
		</div>
	);
};


export default Notification;